import Prismic from 'prismic-javascript';

const leasingApiEndpoint = 'https://graingerplc-sites-customer-portal.cdn.prismic.io/api/v2';
const accessToken = process.env.REACT_APP_PRISMIC_ACCESS_TOKEN;

const apiEndpoint = 'https://grainger-global.cdn.prismic.io/api/v2';

export const getLeasingAPI = () => Prismic.api(leasingApiEndpoint, {accessToken});

export const getAPI = () => Prismic.api(apiEndpoint);

export const getGlobal = (api, items = []) => {
  if (!api.getByUID || !items.length) {
    throw new Error('Please provide Prismic API object to use this function');
  }

  let promises = items.map(item =>
    new Promise((resolve, reject) => {
      api.getByUID(item, item)
        .then(data => resolve(data))
        .catch(error => reject(error))
    }));

  return Promise
    .all(promises)
    .then((response) => {
      let globalItems = {};
      response.forEach(responseItem => {
        globalItems[responseItem.uid] = responseItem.data;
      });
      return globalItems;
    });
}



// WEBPACK FOOTER //
// ./src/utils/cms.js